export const ACTIONS = {
  ORDER_ITEMS_FETCH_START: 'ORDER_ITEMS_FETCH_START',
  ORDER_ITEMS_FETCH_SUCCESS: 'ORDER_ITEMS_FETCH_SUCCESS',
  ORDER_ITEMS_FETCH_FAILURE: 'ORDER_ITEMS_FETCH_FAILURE',
  ORDER_ITEMS_FETCH_RESET: 'ORDER_ITEMS_FETCH_RESET',

  ORDER_ITEMS_CHECK_IN_FETCH_START: 'ORDER_ITEMS_CHECK_IN_FETCH_START',
  ORDER_ITEMS_CHECK_IN_FETCH_SUCCESS: 'ORDER_ITEMS_CHECK_IN_FETCH_SUCCESS',
  ORDER_ITEMS_CHECK_IN_FETCH_FAILURE: 'ORDER_ITEMS_CHECK_IN_FETCH_FAILURE',
  ORDER_ITEMS_CHECK_IN_FETCH_RESET: 'ORDER_ITEMS_CHECK_IN_FETCH_RESET',

  ORDER_ITEM_FETCH_START: 'ORDER_ITEM_FETCH_START',
  ORDER_ITEM_FETCH_SUCCESS: 'ORDER_ITEM_FETCH_SUCCESS',
  ORDER_ITEM_FETCH_FAILURE: 'ORDER_ITEM_FETCH_FAILURE',
  ORDER_ITEM_FETCH_RESET: 'ORDER_ITEM_FETCH_RESET',

  ORDER_ITEM_CREATE_START: 'ORDER_ITEM_CREATE_START',
  ORDER_ITEM_CREATE_SUCCESS: 'ORDER_ITEM_CREATE_SUCCESS',
  ORDER_ITEM_CREATE_FAILURE: 'ORDER_ITEM_CREATE_FAILURE',
  ORDER_ITEM_CREATE_RESET: 'ORDER_ITEM_CREATE_RESET',

  ORDER_ITEM_UPDATE_START: 'ORDER_ITEM_UPDATE_START',
  ORDER_ITEM_UPDATE_SUCCESS: 'ORDER_ITEM_UPDATE_SUCCESS',
  ORDER_ITEM_UPDATE_FAILURE: 'ORDER_ITEM_UPDATE_FAILURE',
  ORDER_ITEM_UPDATE_RESET: 'ORDER_ITEM_UPDATE_RESET',

  ORDER_ITEM_DELETE_START: 'ORDER_ITEM_DELETE_START',
  ORDER_ITEM_DELETE_SUCCESS: 'ORDER_ITEM_DELETE_SUCCESS',
  ORDER_ITEM_DELETE_FAILURE: 'ORDER_ITEM_DELETE_FAILURE',
  ORDER_ITEM_DELETE_RESET: 'ORDER_ITEM_DELETE_RESET',
};
